import { NavLink } from "react-router-dom";
import { FaHome, FaFile, FaUserCheck, FaAddressBook, FaCog, FaUser } from "react-icons/fa";

const Cardmenu = ({ isOpen }: { isOpen: boolean }) => {

  const linkClasses = ({ isActive }: { isActive: boolean }) =>
    `flex items-center gap-x-4 p-2 hover:bg-yellowlight hover:text-gray-900 text-white rounded-md mt-2 cursor-pointer ${
      isActive ? "bg-orange text-gray-900" : ""
    }`;

  const iconSize = isOpen ? "text-xl" : "text-3xl"; // Cambiar el tamaño del icono según el estado del sidebar

  return (
    <ul className="pt-1">
      <NavLink to="/admin/paginaprincipal" className={linkClasses}>
        <FaHome className={iconSize} />
        <span className={`${!isOpen && "hidden"} origin-left duration-200`}>Inicio</span>
      </NavLink>
      <NavLink to="/admin/reglamento" className={linkClasses}>
        <FaAddressBook className={iconSize} />
        <span className={`${!isOpen && "hidden"} origin-left duration-200`}>Reglamento</span>
      </NavLink>
      <li className={`text-yellowlight font-bold mb-2 ${!isOpen && 'hidden'}`}>Descargos laborales</li>
      <NavLink to="/admin/registroempleados" className={linkClasses}>
        <FaFile className={iconSize} />
        <span className={`${!isOpen && "hidden"} origin-left duration-200`}>Crear Empleados</span>
      </NavLink>

      <NavLink to="/admin/perfiles" className={linkClasses}>
        <FaUserCheck className={iconSize} />
        <span className={`${!isOpen && "hidden"} origin-left duration-200`}>Lista de empleados</span>
      </NavLink>

    
     

<NavLink to="/admin/descargoslista" className={linkClasses}>
  <FaFile className={iconSize}  />
  <span className={`${!isOpen && 'hidden'} origin-left duration-200`}>Registrar Descargos</span>
</NavLink>



<NavLink to="/admin/descargoslista" className={linkClasses}>
  <FaAddressBook className={iconSize}  />
  <span className={`${!isOpen && 'hidden'} origin-left duration-200`}>Diagnostico Final</span>
</NavLink>



      <li className={`text-yellowlight font-bold mb-2 ${!isOpen && "hidden"}`}>Configuracion</li>

      <NavLink to="/admin/capacitaciones" className={linkClasses}>
  <FaUser className={iconSize} />
  <span className={`${!isOpen && 'hidden'} origin-left duration-200`}> Capacitaciones</span>
</NavLink> 

      <NavLink to="" className={linkClasses}>
        <FaCog className={iconSize} />
        <span className={`${!isOpen && "hidden"} origin-left duration-200`}>Configuracion</span>
      </NavLink>
      <NavLink to="" className={linkClasses}>
  <FaUserCheck className={iconSize}  />
  <span className={`${!isOpen && 'hidden'} origin-left duration-200`}>Ayuda</span>
</NavLink>


    </ul>
  );
};

export default Cardmenu;
